import { startCase } from 'lodash'
import { QueryHelper } from 'shared'

export const encodedShareURL = (url: string, utmParams: Record<string, string>) => {
  return encodeURIComponent(`${url}?${QueryHelper.toQuery(utmParams)}`)
}

export const openPopup = (url: string) => {
  void window.open(url, 'sharer', 'toolbar=no,width=1042,height=436')
}

export const facebookAppId = () => {
  return document.head.querySelector<HTMLMetaElement>("[property='fb:app_id']")?.content
}

export const utmParams = (campaign: string, context: string, platform: string) => {
  // "facebook_messenger" becomes "Facebook Messenger"
  const humanReadablePlatform = startCase(platform)

  return {
    utm_campaign: campaign,
    utm_medium: `${context}_${platform}`,
    utm_source: humanReadablePlatform,
  }
}
